import { render, staticRenderFns } from "./ConfirmationButtons.vue?vue&type=template&id=24e60e30&scoped=true&"
import script from "./ConfirmationButtons.vue?vue&type=script&lang=js&"
export * from "./ConfirmationButtons.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationButtons.vue?vue&type=style&index=0&id=24e60e30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e60e30",
  null
  
)

export default component.exports